export const CLICK_EVENTS = [ "click", "quantity_change", "cat_count" ] as const;
export const CLOSE_EVENTS = [ "close_accordion", "close_menu", "close_modal" ] as const;
export const OPEN_EVENTS = [ "open_accordion", "open_menu", "open_modal" ] as const;
export const PURCHASE_EVENTS = [ "purchase" ] as const;
export const SUBMIT_EVENTS = [ "submit_attempted", "submit_failed", "submit_successful" ] as const;
export const VIEW_EVENTS = [ "view_advert", "view_tooltip", "view_messaging", "view_default_recipes" ] as const;

export type TClickEvent = typeof CLICK_EVENTS[number];
export type TCloseEvent = typeof CLOSE_EVENTS[number];
export type TOpenEvent = typeof OPEN_EVENTS[number];
export type TViewEvent = typeof VIEW_EVENTS[number];
export type TSubmitEvent = typeof SUBMIT_EVENTS[number];
export type TPurchaseEvent = typeof PURCHASE_EVENTS[number];

export type TEventName =
  | TClickEvent
  | TCloseEvent
  | TOpenEvent
  | TViewEvent
  | TSubmitEvent
  | TPurchaseEvent;
